/* Accessibility helpers - Downsized Designs (added 2026-10-27).
 *
 * Provides window.ddAnnounce(message): politely announces a message to
 * assistive technology through the visually hidden live region rendered
 * by layout/theme.liquid (#dd-a11y-announcer). Used for state changes
 * that would otherwise happen silently - favorites toggles, the
 * recently-viewed clear action, favorites-page cart adds.
 * No-ops safely when the region is absent. */
(function () {
  'use strict';
  var pending = null;
  function announce(message) {
    if (typeof message !== 'string' || !message) return;
    var region = document.getElementById('dd-a11y-announcer');
    if (!region) return;
    /* Clear first, then set on a tick, so repeating the same message
       (e.g. adding two favorites in a row) is announced each time. */
    region.textContent = '';
    if (pending) window.clearTimeout(pending);
    pending = window.setTimeout(function () {
      region.textContent = message;
    }, 60);
  }
  window.ddAnnounce = announce;
})();
